'use client';

import React, { useMemo } from 'react';

import { TasticProps } from '../types';
import {
  AlgoliaRecommendationProvider,
  TrendingItems,
} from 'components/commercetools-ui/organisms/product/product-recommendations';
import { useBadgeLoader } from 'helpers/utils/badgeLoader';
import { P2Badge } from 'components/commercetools-ui/organisms/product/product-list-algolia/types';
import useLocale from 'helpers/hooks/useLocale';
import { shouldShowRecommendation } from 'helpers/utils/recommendationUtils';

const AlgoliaTrendingProductTastic = ({ data }: TasticProps<any>) => {
  const { locale } = useLocale();

  const p1BadgeData = data?.data?.dataSource?.p1BadgeData;
  const p2BadgeData = data?.data?.dataSource?.p2BadgeData;

  const p1Badges = useBadgeLoader(p1BadgeData?.productListingContent);
  const p2Badges = p2BadgeData?.productListingContent as P2Badge[];
  const recommendationsConfig = data?.data?.dataSource?.includeExclude?.recommendations || [];

  const queryParameters = data?.data?.dataSource?.searchQuery?.[locale?.replace('-', '_')];

  const currentUrl = typeof window !== 'undefined' ? window.location.pathname : '';
  const recFlags = useMemo(() => {
    return shouldShowRecommendation(
      currentUrl,
      recommendationsConfig,
      'trendingItems',
      data?.isEnableTrending,
      data?.isPLP,
    );
  }, [currentUrl, recommendationsConfig, data?.isEnableTrending]);

  if (!recFlags) return null;

  return (
    <AlgoliaRecommendationProvider>
      <div>
        <TrendingItems
          title={data?.trendingTitle}
          p1BadgeData={p1Badges}
          p2BadgeData={p2Badges}
          queryParameters={queryParameters}
        />
      </div>
    </AlgoliaRecommendationProvider>
  );
};

export default AlgoliaTrendingProductTastic;
